import React,{ useState, useEffect, useRef } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Col, Row } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined  } from '@ant-design/icons';
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

import logo from '../../image/logo.svg'

import Energy1 from '../../image/Energy1-24x24.svg'
import Strength from '../../image/Strength-24x24.svg'
import Endurance from '../../image/Endurance-24x24.svg'
import OptimalLevels from '../../image/Optimal-Levels-24x24.svg'
import Energy2 from '../../image/Energy2-24x24.svg'
import Youthfulness from '../../image/Youthfulness-26x26.svg'
import Resilience from '../../image/Resilience-24x24.svg'
import GentlePower from '../../image/Gentle-Power-24x24.svg'


import Star from '../../components/Star/Star';
import CarouselDom from '../../components/CarouselDom/CarouselDom';
import Community from '../../components/Community/Community'
import ChartBarDom from '../../components/ChartBarDom/ChartBarDom'
import BigCard from '../../components/BigCard/BigCard';
import AutoScrolling from '../../components/AutoScrolling/AutoScrolling';
import AutoSwitching from '../../components/AutoSwitching/AutoSwitching';
import ProductDescription from '../../components/ProductDescription/ProductDescription';

import { getProductList } from '../../api/goods'
import { getBlogList } from '../../api/article'

import './home.less'


echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BarChart,
  CanvasRenderer
]);
const Home = () =>{
  const navigate = useNavigate();
  
  const [width, setWidth] = useState(window.innerWidth);

  let DescriptionList = [{
    type: 'text',
    content: {
      top: '0',
      title: '尼古丁',
      description: '不含尼古丁、焦油等有害物质，以天然植物提取物+科学抗衰成分打造安心雾化体验，让每一次呼吸都轻盈无负担。',
    },
    btnConfig: false
  },{
    type: 'text',
    content: {
      top: '1500',
      title: '长效续航',
      description: '1500口长效续航，告别频繁充电焦虑。',
    },
    btnConfig: false
  },{
    type: 'text',
    content: {
      top: '5-10',
      title: '生物利用度',
      description: '搭载独家专利配方「科学配比NMN+」，生物利用度提升5-10倍，靶向补充NAD+（人体抗衰关键因子），从细胞源头延缓衰老。',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'text',
    content: {
      top: '3',
      title: '三重健康增益',
      description: '(1) 肺部健康：改善肺部纤维化及炎症，提升呼吸效率；(2) 口腔护理：清新口气，减少口腔问题困扰；(3) 精神活力：温和唤醒身体，替代传统提神方式。',
    },
    btnConfig: {
      icon: 'ArrowRightOutlined',
      link: '/science'
    }
  }]
  let productDescriptionData = {
    title: <div>
      全球首款NAD+抗衰雾化器 | 科学配方NMN+，生物利用度提升5-10倍 | 焕活线粒体，延缓衰老，改善口腔和肺部健康 | 水果口味，爆炸薄荷、水晶灯控设计，1500口长效续航
    </div>,
    data: DescriptionList
  }
  
  let GoodCardList = {
    type: 'goodCard', 
    textWidth: '30%',
    title: '线粒体能量工厂',
    description: '日益增长的科学共识表明，通过激活线粒体核心功能并优化细胞代谢水平，能显著降低氧化应激损伤。这一干预路径不仅在预防和缓解呼吸道炎症、增强心肌与神经元能量供给效率方面表现卓越，更能有效对抗机体疲劳、提升卵母细胞质量，从而在系统层面延缓袁老进程，重塑生命张力。',
    cardList:[{
      type: 'img',
      content: {
        title: '对身体的益处',
        img: <img src={require('../../image/sticky-img.webp')} style={{width: '100%',borderRadius:5}}/>,
        list: [
          {name: '降低氧化应激损伤',icon: Energy1},
          {name: '延缓衰老进程',icon: Endurance},
          {name: '增强生命活力',icon: Strength},
          // {name: 'Optimal Levels',icon: OptimalLevels}
        ],
      },
      btnConfig: {
        icon: 'ArrowRightOutlined',
        link: '/science'
      }
    },{
      type: 'img',
      content: {
        title: '前往科学',
        img: <img src={require('../../image/bigCardBg2-1200x964.png')} style={{width: '100%',borderRadius:5}}/>,
        list: [
          {name: '线粒体稳态维持',icon: Energy2},
          {name: 'SASP袁老环境清除',icon: Youthfulness},
          {name: '线粒体移植技术',icon: Resilience},
          // {name: 'Gentle power',icon: GentlePower}
        ],
      },
      btnConfig: {
        icon: 'ArrowRightOutlined',
        link: '/science'
      }
    }]
  }

  
  let [bannerLink, setBannerLink] = useState('')
  let [goodsList, setGoodsList] = useState([])
  let goodsCarouselData = {
    CarouselText: '还不确定？试试我们的样品',
    btnText: '店铺样品',
    link: '/shop'
  }

  let communityData = {
    cardList: [{
      type: 'card',
      star: 5,
      title: 'I feel like I have gotten younger',
      content: `I simply feel like I have more energy to do everything.  This is like a caffeine jolt without any of the side effects.  I am hoping these results continue and build on what is currently happening?  I'm willing to continue for a couple of months to find out.`,
      name: 'Kathryn C',
      productImg: require('../../image/shop1-1200x1200.avif'),
      productName: 'Mitopure Softgels',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Great Addition to Skincare Routine!',
      content: `The night cream has been a great addition to my skincare routine.  I feel it has lightened my dark spots and made my skin less dull.  It feels indulgent but is still an affordable addition to my lotions and potions!`,
      name: 'Jolene M',
      productImg: require('../../image/shop4-1200x1200.avif'),
      productName: 'The Night Cream',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Actually works!',
      content: `I grabbed the Time-Line Day Cream for my wife due to some uneven skin tone she was going through after having our daughter a year ago. She started a month ago, and we definitely saw the change! My wife's skin tone became smoother and clearer. Many of the blemishes and uneven skin tone had disappeared. This product is amazing!`,
      name: 'Nadim H',
      productImg: require('../../image/shop2-1200x1200.avif'),
      productName: 'The Day Cream',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Wonderful',
      content: `This serum truly makes you look younger and feel confident. I felt like my wrinkles were fading and my skin felt tighter after just one week. I also look brighter and moisturized ! I recommend this serum to anyone looking for a little help looking bright and youthful!`,
      name: 'Marleise C',
      productImg: require('../../image/shop5-1200x1200.avif'),
      productName: 'The Serum',
      link: '',
    }],
    videoList: [{
      type: 'video',
      cardType: 'doctor',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'Dr. Mark Hyman, MD',
      achievement: 'Functional Medicine Physician, 15x New York Times Bestselling Author'
    },{
      type: 'video',
      cardType: 'doctor',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'Dr. Gabrielle Lyon',
      achievement: 'Founder Institute for Muscle-Centric Medicine®'
    },{
      type: 'video',
      cardType: 'userComment',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'idodeclaire2013',
      productImg: require('../../image/shop1-1200x1200.avif'),
      productName: 'Mitopure Softgels',
    },{
      type: 'video',
      cardType: 'userComment',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'chrisellelim',
      productImg: require('../../image/shop5-1200x1200.avif'),
      productName: 'The Serum',
    }]
  }

  let expertList = [{
    img: require('../../image/expert-ErwinSchrödinger.png'),
    name: '薛定谔(Erwin Schrödinger)',
    identity: '埃尔温·薛定谔(Erwin Schrödinger，1887年8月12日-1961年1月4日)，奥地利理论物理学家，量子力学奠基人之一。获933年诺贝尔物理学奖，',
    sentence: `“生命以'负熵'为生，生命本质上是一个通过不断从环境中汲取秩序，以抵抗自身趋向无序与平衡(死亡)的过程。”---《生命是什么--活细胞的物理面貌》`
  },{
    img: require('../../image/expert-DouglasWallace.png'),
    name: 'Douglas Wallace',
    identity: '线粒体遗传学之父，费城儿童医院中心主任;曾任职于埃默里大学及加州大学欧文分校，美国国家科学院院士',
    sentence: `“线粒体DNA变异是决定人类适应气候、产生疾病及个体衰老的'生命时钟'。”`
  },{
    img: require('../../image/expert-ZhenglongGu.png'),
    name: '顾正龙',
    identity: '国际知名遗传学家，复旦大学特聘教授，康奈尔大学客座教授。现任粤港澳大湾区精准医学研究院（广州）助理院长、线粒体遗传与健康研究中心主任',
    sentence: '“衰老就是一个组织失序的过程。随着时间流逝，线粒体功能下降，组织也越来越无序，很多疾病和可感知的衰老进程就发生了。”'
  },{
    img: require('../../image/expert-NavdeepChandel.png'),
    name: 'Navdeep Chandel',
    identity: '西北大学费恩伯格医学院讲席教授;长期深耕线粒体活性氧(ROS)与代谢信号传导研究。',
    sentence: `“线粒体远不止是能量工厂，它通过释放信号分子指挥着细胞的免疫与生存决策。”`
  },{
    img: require('../../image/expert-VamsiMootha.png'),
    name: 'Vamsi Mootha',
    identity: '哈佛医学院及麻省理工Broad研究所教授;霍华德·休斯医学研究所(HHMI)研究员。',
    sentence: '“通过绘制线粒体蛋白全谱(MitoCarta)，揭示了缺氧环境对修复功能的潜力。”'
  }]
  let AutoSwitchingData = {
    title: '了解专家,信任HappyCell',
    data: expertList
  }

  let [articleList, setArticleList] = useState([{
    type: 'img2',
    content: {
      img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
      title: 'New Study: Mitopure Improves Muscle Health in Athletes',
      taglist: ['News', 'Nutrition','Studies'],
      time:'Dec 19, 2024'
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'img2',
    content: {
      img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
      title: 'The Future of Longevity Medicine: Breakthroughs from 2024',
      taglist: ['News', 'Nutrition','Studies'],
      time:'Dec 19, 2024'
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'img2',
    content: {
      img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
      title: `2024's Most Important Urolithin A Studies `,
      taglist: ['News', 'Nutrition','Studies'],
      time:'Dec 19, 2024'
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'img2',
    content: {
      img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
      title: 'Sleep’s Role in Brain Function for Brain Health',
      taglist: ['News', 'Nutrition','Studies'],
      time:'Dec 19, 2024'
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'img2',
    content: {
      img: <img src={require('../../image/article1-2640x1760.png')} style={{width: '100%',borderRadius:5}}/>,
      title: 'Top Foods to Boost Your Immune System',
      taglist: ['News', 'Nutrition','Studies'],
      time:'Dec 19, 2024'
    },
    btnConfig: {
      link: ''
    }
  }])
  let articleCarouselData = {
    CarouselText: '线粒体观点',
    btnText: '前往',
    link: '/science'
  }
  

  // 获取商品列表
  const getProductListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      prodType: '0',
      prodStatus: '1',
    }
    let res = await getProductList(update)
    console.log(res)
    if(res?.msg === 'success'){
      let data = res?.data.map(e=>{
        return ({
          type: 'goods',
          content:{
            title: e.prodName,
            description: e.description,
            img: e.prodImg1,
            imgHover: e.prodImg2,
            // star: 4.4,
            // commentCount: 2813,
            bestseller: false,
            tag: false
          },
          btnConfig:{
            link:`/shopDetail?id=${e.id}`,
          }
        })
      })
      console.log(data[0])
      if(data[0]){
        setBannerLink(()=> `${data[0].btnConfig.link}`)
        setGoodsList(()=> data)
      }
    }
  }
  // 获取文章列表
  const getBlogListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      status: 1,
      // categoryType: 1
    }
    let res = await getBlogList(update)
    console.log('BlogList', res?.data)
    if(res?.msg === 'success'){
      let data = res?.data.map((e,i)=>{
        // console.log(e)
        const now = new Date(e.publishedTime);
        const Y = now.getFullYear();
        const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const D = String(now.getDate()).padStart(2, '0');
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        const s = String(now.getSeconds()).padStart(2, '0');

        return {
          type: 'img2',
          content: {
            // img: <img src={e.coverImage} style={{width: '100%',borderRadius:5}}/>,
            img: <div style={{width: '100%',height:'20vh',background: `url(${e.coverImage}) no-repeat center center/cover`}}></div>,
            title: e.title,
            // taglist: ['News', 'Nutrition','Studies'],
            time: `${Y}-${M}-${D} ${h}:${m}:${s}`
          },
          btnConfig: {
            link: e.articleUrl? e.articleUrl:`/aBoutDetail?id=${e.id}`,
            linkType: e.articleUrl? '_blank':''
          }
        }
      })
      // console.log(res?.data)
      setArticleList(()=> data)
    }
  }
  useEffect(()=>{
    getProductListFn()
    getBlogListFn()

    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])


  return (
    <div className="home-page" style={{background: '#fff'}}>
      {/* 视频 */}
      {width > 770 && <div className="home-video-box">
        <div className="video-content-box">
          {/* <div className="text">Powered by <img style={{height: 22,verticalAlign: 'top'}} src={logo} alt=""/></div> */}
          <div className="text" style={{fontSize:12, padding:'16px 0',borderTop:' 2px dotted #fff'}}>临床验证的益处</div>
          <div>
            <div className="text big-text" style={{opacity: 0.5}}>焕新</div>
            <div className="text big-text" style={{opacity: 0.5}}>活力</div>
            <div className="text big-text" style={{opacity: 0.5}}>澎湃</div>
            <div className="text big-text">年轻能量</div>
          </div>
          <div className="text" style={{fontWeight:200}}>聚焦线粒体稳态与代谢微环境优化的健康解决方案</div>
          {/* <button className="video-content-box-btn" onClick={()=> {
            console.log(goodsList[0])
            navigate(bannerLink)
          }}>购 买</button> */}
        </div>

        {/* <div className="video-tag-box" style={width > 770? {}:{left: 0,right: 0,margin: 'auto'}}>
          <div className="text1">#1</div>
          <div>
            <div className="text2">Doctor Recommended</div>
            <div className="text3">Urolithin A Brand</div>
          </div>
        </div> */}

        <img style={{width:'100%'}}  src={require("../../image/home-banner.jpg")} alt="" />
        {/* <video
          style={{width:'100%'}} 
          poster={require("../../image/Homepage_2_Sept-1_sz4qhr.webp")}
          src={require("../../video/Homepage_2_Sept-1_sz4qhr.mp4")}
          autoPlay 
          loop
          muted
          preload="auto"
        >
          <source src={require("../../video/Homepage_2_Sept-1_sz4qhr.mp4")} type="video/mp4"></source>
        </video> */}
      </div>}

      {width < 770 && <div className="video-content-box-phone">
        <img style={{width:'100%'}}  src={require("../../image/home-banner.jpg")} alt="" />
        {/* <div className="text">Powered by <img style={{height: 22,verticalAlign: 'top'}} src={logo} alt=""/></div> */}
        
        <div className="text-box">
          <div className="text big-text" style={{opacity: 0.5,paddingLeft:25}}>焕新</div>
          <div className="text big-text" style={{opacity: 0.5}}>活力</div>
          <div className="text big-text" style={{opacity: 0.5}}>澎湃</div>
          <div className="text big-text">年轻能量</div>

          <div className="text" style={{fontSize:12, padding: '0 25px', color:'rgba(255, 255, 255, 0.54)'}}>聚焦线粒体稳态与代谢微环境优化的健康解决方案</div>
        </div>
        {/* <button className="video-content-box-btn" onClick={()=> navigate(bannerLink)}>购 买</button> */}
      </div>}

      {width > 770? 
        <div className="home-detail">
          <div className="home-detail-content">
            <div>在生命科学的最前沿，线粒体科学正在重新定义人类衰老的边界。我们坚信，衰老并非不可逆转的宿命，而是一场可以被精准干预的细胞管理工程。</div>
            <div>凭借在线粒体科学领域的深厚积淀与严谨研究，我们专注于通过多维度的技术路径，从底层逻辑重构生命活力。我们的研究成果正逐步从实验室走向真实生活，将曾经难以逾越的病理困境转化为可治愈、可改善的健康图景。不仅仅是在对抗衰老，更是在进行一场精密的生物修复:</div>
          </div>
        </div>
        :
        <div className="home-detail-phone">
          <div className="home-detail-content">
            <div>在生命科学的最前沿，线粒体科学正在重新定义人类衰老的边界。我们坚信，衰老并非不可逆转的宿命，而是一场可以被精准干预的细胞管理工程。</div>
            <div>凭借在线粒体科学领域的深厚积淀与严谨研究，我们专注于通过多维度的技术路径，从底层逻辑重构生命活力。我们的研究成果正逐步从实验室走向真实生活，将曾经难以逾越的病理困境转化为可治愈、可改善的健康图景。不仅仅是在对抗衰老，更是在进行一场精密的生物修复:</div>
          </div>
        </div>
      }
      

      {/* 评论 */}
      {/* <Row className={width > 770 ? "comment-box":"comment-box-phone"} wrap={false}>
        <Col flex={width > 770? "300px":'0'} style={width > 770? {display:'flex', alignItems:'center'}:{display:'flex',justifyContent:'center'}}>
          <Star score={4.5}/>
          <span style={{marginLeft: 10}}>4682+ trusted reviews</span>
        </Col>
        <Col flex="auto">
          <AutoScrolling />
        </Col>
      </Row> */}

      {/* 产品描述 */}
      {/* <ProductDescription productDescriptionData={productDescriptionData}/> */}
      
      
      <BigCard bigCardData={GoodCardList}/>

      {/* <ChartBarDom /> */}
      

      {/* 商品轮播图 */}
      <CarouselDom CarouselData={{data:goodsList, ...goodsCarouselData}}/>
      {/* <CarouselDom CarouselData={goodsCarouselData} data={goodsList}/> */}
      
      
      {/* <AutoScrolling /> */}

      {/* 社区 */}
      {/* <Community communityData={communityData}/> */}

      {/* 专家 */}
      <AutoSwitching AutoSwitchingData={AutoSwitchingData}/>

      {/* 文章轮播 */}
      <CarouselDom CarouselData={{data:articleList, ...articleCarouselData}}/>
      {/* <CarouselDom CarouselData={articleCarouselData} data={articleList}/> */}
      

    </div>
  )
}

export default Home